// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viral-clips-metadata-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.page-header h1 {
  font-size: 32px;
  color: #333;
  margin: 0;
}

.job-selector {
  display: flex;
  align-items: center;
  gap: 12px;
}

.job-selector label {
  font-weight: 600;
  color: #555;
}

.job-selector select {
  padding: 10px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  font-size: 14px;
  min-width: 200px;
  color: #333;
  cursor: pointer;
}

.job-selector select:focus {
  outline: none;
  border-color: #4a6bdf;
  box-shadow: 0 0 0 2px rgba(74, 107, 223, 0.2);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
  text-align: center;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4a6bdf;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-container p {
  color: #666;
  font-size: 16px;
}

.error-container {
  text-align: center;
  padding: 40px;
  background-color: #fff1f0;
  border-radius: 12px;
  margin: 20px 0;
}

.error-message {
  color: #d32f2f;
  margin-bottom: 20px;
  font-size: 16px;
}

.retry-button {
  padding: 10px 20px;
  background-color: #4a6bdf;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.retry-button:hover {
  background-color: #3a56b0;
}

.no-job-selected {
  text-align: center;
  padding: 60px;
  background-color: #f8f9fa;
  border-radius: 12px;
  border: 2px dashed #ddd;
}

.no-job-selected p {
  color: #666;
  font-size: 18px;
}

/* Responsive styles */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .job-selector {
    width: 100%;
  }
  
  .job-selector select {
    flex: 1 1;
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/ViralClipsMetadataPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;AACF","sourcesContent":[".viral-clips-metadata-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 24px;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.page-header h1 {\n  font-size: 32px;\n  color: #333;\n  margin: 0;\n}\n\n.job-selector {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.job-selector label {\n  font-weight: 600;\n  color: #555;\n}\n\n.job-selector select {\n  padding: 10px 16px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #fff;\n  font-size: 14px;\n  min-width: 200px;\n  color: #333;\n  cursor: pointer;\n}\n\n.job-selector select:focus {\n  outline: none;\n  border-color: #4a6bdf;\n  box-shadow: 0 0 0 2px rgba(74, 107, 223, 0.2);\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px;\n  text-align: center;\n}\n\n.loader {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #4a6bdf;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-container p {\n  color: #666;\n  font-size: 16px;\n}\n\n.error-container {\n  text-align: center;\n  padding: 40px;\n  background-color: #fff1f0;\n  border-radius: 12px;\n  margin: 20px 0;\n}\n\n.error-message {\n  color: #d32f2f;\n  margin-bottom: 20px;\n  font-size: 16px;\n}\n\n.retry-button {\n  padding: 10px 20px;\n  background-color: #4a6bdf;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.retry-button:hover {\n  background-color: #3a56b0;\n}\n\n.no-job-selected {\n  text-align: center;\n  padding: 60px;\n  background-color: #f8f9fa;\n  border-radius: 12px;\n  border: 2px dashed #ddd;\n}\n\n.no-job-selected p {\n  color: #666;\n  font-size: 18px;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .job-selector {\n    width: 100%;\n  }\n  \n  .job-selector select {\n    flex: 1;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
